import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Sidebar from './Sidebar';
import { Button } from '../ui/button';
import { Icon } from '../common/Icon';
import { cn } from '../../lib/utils';
import EmailVerificationBanner from '../common/EmailVerificationBanner';
import { useAuth } from '../../context/AuthContext';
import { useSiteSettings } from '../../context/SiteSettingsContext';

export function DashboardLayout() {
  const { t } = useTranslation('shared');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const { require_email_verification: requireEmailVerification } = useSiteSettings();
  const verificationBlocked = requireEmailVerification && user && !user.email_verified && !user.email_verification_exempt;

  return (
    <div className="auth-workspace min-h-screen bg-slate-50">
      <Header />
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Mobile-only sidebar toggle — opens the role Sidebar drawer.
          Hidden on md+ where the Sidebar is permanently visible. */}
      <Button
        variant="outline"
        size="sm"
        onClick={() => setSidebarOpen(true)}
        className="md:hidden fixed start-3 z-30 h-9 px-3 shadow-sm bg-background"
        style={{ top: 'calc(var(--header-h, 4rem) + 0.5rem)' }}
        aria-label={t('menu.open')}
        data-testid="dashboard-sidebar-toggle"
      >
        <Icon name="menu" className="h-4 w-4 me-2" />
        {t('dashboard.menu')}
      </Button>

      <main
        className={cn(
          'auth-workspace-main pt-5 md:pt-7 pb-12 transition-all duration-200',
          'md:ms-64 px-4 sm:px-6 lg:px-8 2xl:px-10',
        )}
        style={{ minHeight: 'calc(100vh - var(--header-h, 4rem))' }}
      >
        {/* Top spacer on mobile so content doesn't sit under the floating Menu button */}
        <div className="h-10 md:hidden" aria-hidden="true" />
        <div className="auth-workspace-content mx-auto w-full">
          {user?.tester_campaign && <div className="mb-5 rounded-xl border border-orange-300 bg-orange-50 p-4 text-slate-900"><Link to="/testing/onboarding" className="font-semibold underline">Tester onboarding and your free benefit</Link></div>}
          <EmailVerificationBanner blocking={verificationBlocked} />
          {!verificationBlocked && <Outlet />}
        </div>
      </main>
    </div>
  );
}

export default DashboardLayout;
